import { constants } from '@/constants'
export default {
  methods: {
    formatDate (dateString: string, options: Intl.DateTimeFormatOptions = { dateStyle: 'short' }, lang = 'hu-HU') {
      if (dateString !== '' && dateString != null && dateString !== undefined) {
        const date = new Date(dateString)
        return new Intl.DateTimeFormat(lang, options).format(date)
      }
    },
    formatDateAndTime (dateString: string, hideSeconds?: boolean) {
      if (dateString) {
        const date = new Date(dateString)
        return new Intl.DateTimeFormat('hu-HU', { dateStyle: 'short', timeStyle: hideSeconds ? 'short' : 'medium' }).format(date)
      }
    },
    formatCurrency (currency: number) {
      return new Intl.NumberFormat('hu-HU', { style: 'currency', currency: 'HUF', useGrouping: true }).format(currency)
    },
    formatCurrencyWithoutDecimals (currency: number) {
      let price = new Intl.NumberFormat('hu-HU', { style: 'currency', currency: 'HUF', useGrouping: true }).format(currency)
      const comma = price?.search(',')
      if (comma !== -1) {
        price = price.slice(0, comma) + price.slice(comma + 3)
      }
      return price
    },
    minusValue (value: number) {
      return value > 0 ? -value : value
    },

    formateDateWithoutLocale (date: string) {
      if (date && typeof date === 'string') {
        const structuredDate = new Date(date)
        if (structuredDate) {
          return `${structuredDate.getFullYear()}.${('0' + (structuredDate?.getMonth() + 1))?.slice(-2)}.${('0' + structuredDate.getDate()).slice(-2)}`
        }
      }
      return ''
    },

    formateDateWithoutLocaleYMD (date: string) {
      if (date && typeof date === 'string') {
        const structuredDate = new Date(date)
        if (structuredDate) {
          return `${structuredDate.getFullYear()}.${('0' + (structuredDate?.getMonth() + 1))?.slice(-2)}.${('0' + structuredDate.getDate()).slice(-2)}`
        }
      }
      return ''
    },

    formateDateAndTimeWithoutLocale (date: string) {
      if (date && typeof date === 'string') {
        const structuredDate = new Date(date)
        if (structuredDate) {
          return `${('0' + structuredDate.getDate()).slice(-2)}.${('0' + (structuredDate?.getMonth() + 1))?.slice(-2)}.${structuredDate.getFullYear()} ${('0' + structuredDate.getHours()).slice(-2)}:${('0' + structuredDate.getMinutes()).slice(-2)}`
        }
      }
      return ''
    },

    formateDateAndTimeWithoutLocaleNoTime (date: string) {
      if (date && typeof date === 'string') {
        const structuredDate = new Date(date)
        if (structuredDate) {
          return `${('0' + structuredDate.getDate()).slice(-2)}.${('0' + (structuredDate?.getMonth() + 1))?.slice(-2)}.${structuredDate.getFullYear()}`
        }
      }
      return ''
    }
  }
}
